import { FormAnswerByQnID } from '../../../../models/FormProps';
import { isEmpty } from '../../../../utils/equality';
import { UserMetadata } from '../../../BaseElement';
import { findElement, RootElement } from '../../../RootElement';
import { Op } from '../../DisplayCondition';
import { meetsDisplayConditions } from '../../DisplayConditionsContainer';
import { BaseQuestionDisplayCondition, newBaseQuestionDisplayCondition } from '../QuestionDisplayCondition';

export const MultipleResponseQuestionDisplayConditionType = 'DisplayCondition::Question::Mrq';

export interface MultipleResponseQuestionDisplayCondition extends BaseQuestionDisplayCondition {
  value: string | null;
}

export function newMultipleResponseQuestionDisplayCondition(question_id: string | null, value: string | null) {
  return {
    ...newBaseQuestionDisplayCondition(MultipleResponseQuestionDisplayConditionType, question_id),
    value
  };
}

export function meetsMultipleResponseQuestionDisplayCondition(condition: MultipleResponseQuestionDisplayCondition, root: RootElement, answerByQnID: FormAnswerByQnID, userMetadata: UserMetadata) {
  const { op, question_id, value } = condition;

  switch (op) {
    case Op.Eq: {
      const answer = answerByQnID[question_id];

      if (isEmpty(answer.values)) {
        return false;
      }

      if (answer.values.includes(value)) {
        const refQuestion = findElement(root, question_id);
        return meetsDisplayConditions(refQuestion, root, answerByQnID, userMetadata);
      }

      return false;
    }
    default:
      return false;
  }
}
